<div
  *ngIf="!isLoggedIn"
  class="invitee-logo-wrapper">
  <img
    class="login-logo"
    src="assets/static/inpool__white.svg"
    alt="InPool Logo" />
</div>
<div class="time-tracking-form">
  <div class="d-flex justify-content-between mb-4">
    <h1
      class="mb-2"
      data-cy="time-tracking-form-job-title">
      {{ ("job" | i18n) || "Dienst" }}
    </h1>
    <span
      *ngIf="jobInfo"
      data-cy="time-tracking-form-status-display">
      {{ ("state" | i18n) || "Status" | titlecase }}:
      <b
        *ngIf="timeTrackingStatus === 'TO_ADD'"
        data-cy="time-tracking-form-status-to-add"
        >{{ ("toAdd" | i18n) || "hinzuzufügen" | titlecase }}</b
      >
      <b
        *ngIf="timeTrackingStatus === 'TO_APPROVE'"
        data-cy="time-tracking-form-status-to-approve"
        >{{ ("toApprove" | i18n) || "zu bestätigen" | titlecase }}</b
      >
      <b
        *ngIf="timeTrackingStatus === 'APPROVED'"
        data-cy="time-tracking-form-status-approved"
        >{{ ("approved" | i18n) || "freigegeben" | titlecase }}</b
      >
    </span>
  </div>
  <div *ngIf="jobInfo">
    <div
      class="jobInfo__date"
      data-cy="time-tracking-form-job-date">
      <div class="jobInfo__title-bold">
        {{ jobInfo.date | date: "EEEEEE. dd.MM.yyyy" }}
        |&nbsp;
      </div>
      <div class="d-flex">
        <div *ngFor="let shift of jobInfo.shifts">
          {{ shift.from | time }} - {{ shift.to | time }} Uhr
        </div>
      </div>
    </div>
    <div
      class="mb-2"
      data-cy="time-tracking-form-department-name">
      {{ jobInfo.departmentDisplayName }}
    </div>
    <div
      class="mb-2"
      *ngIf="jobInfo.description"
      data-cy="time-tracking-form-job-description">
      {{ ("description" | i18n) || "Beschreibung" }}:
      {{ jobInfo.description }}
    </div>
    <div
      *ngIf="jobInfo.invitee && jobInfo.isCustomer"
      class="mt-3 jobInfo__invitee-name"
      data-cy="time-tracking-form-invitee-info">
      <mat-icon
        class="inline-icon"
        svgIcon="account"></mat-icon>
      <span data-cy="time-tracking-form-name-display">
        {{ jobInfo.invitee.personalData?.firstName }}
        {{ jobInfo.invitee.personalData?.lastName }}</span
      >
      <span
        *ngIf="jobInfo.invitee.personalData?.phone"
        data-cy="time-tracking-form-phone-display">
        / {{ jobInfo.invitee.personalData?.phone }}</span
      >
      <span
        *ngIf="jobInfo.invitee.personalData?.email"
        data-cy="time-tracking-form-email-display">
        / {{ jobInfo.invitee.personalData?.email }}</span
      >
    </div>
    <div class="mt-2">
      <h3>
        {{ ("hours" | i18n) || "Stunden" | titlecase }}
      </h3>
      <app-time-tracking
        [job]="jobInfo.job"
        [invitee]="jobInfo.invitee"
        [isPooler]="!jobInfo.isCustomer"
        (timeTrackingSubmitted)="updateTimeTrackingStatus()"
        isMagicLink
        [magicSecret]="secret"
        data-cy="time-tracking-form-time-tracking-component"></app-time-tracking>
    </div>
  </div>
  <div *ngIf="!jobInfo">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
